import React, { useEffect, useState } from 'react'
import { Get_Api } from '../API_URL';
import RequestModel from '../Components/slider/RequestModel';
import Aos from 'aos';
import TwitterCompoent from '../Components/slider/TwitterCompoent';
import DotWeeklyimg from '../Assets/DotWeeklyimg.jpg'

function TheCorridor() {
    const [activeTab, setActiveTab] = useState("DotWeekly");
    const [isUploading, setIsUploading] = useState(false);
    const [AllReport, setAllReport] = useState([]);
    const [AllBriefs, setAllBriefs] = useState([]);
    const [visibleCount, setVisibleCount] = useState(4);

    useEffect(() => {
        setVisibleCount(4);
    }, [activeTab]);

    const handleViewMore = () => {
        setVisibleCount(prev => prev + 4);
    };



    const Get_All_Report = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api("api/admin/GetAllReportWeb");
            const reports = response?.data?.filter(item => item?.Type === "Reports");
            const briefs = response?.data?.filter(item => item?.Type === "Briefs");
            setAllReport(reports);
            setAllBriefs(briefs)
            setIsUploading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        Get_All_Report();
    }, []);

    const formatTitle = (title = "") => {
        const text = title.toLowerCase().trim();
        return text.charAt(0).toUpperCase() + text.slice(1);
    };


    const [selectedReport, setselectedReport] = useState(null);
    const [ReportRequestModel, setReportRequestModel] = useState(false);

    const OpenReportRequest = (data) => {
        setselectedReport(data)
        setReportRequestModel(true)
    }

    const CloseReportRequest = () => {
        setselectedReport(null)
        setReportRequestModel(false)
    }
    useEffect(() => {
        Aos.init({
            duration: 1000, // animation speed
            once: true,     // run only once
            easing: "ease-out",
        });
    }, []);

    const [AllDotweekly, setAllDotweekly] = useState([]);

    const GetAllDotWeekly = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api("api/admin/GetAllCampaigns");
            setAllDotweekly(response?.data)
            setIsUploading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    useEffect(() => {
        GetAllDotWeekly();
    }, []);

    const getTitle = (item) => {
        const hasIssue = (s) => /issue/i.test(s || "");
        if (hasIssue(item.subject)) return item.subject;
        if (hasIssue(item.title)) return item.title;
        return item.subject || item.title || "No title";
    };

    const toHttps = (url) => (url ? url.replace(/^http:\/\//i, "https://") : "#");

    const formatDate = (d) =>
        new Date(d).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });

    const Loading = () => {
        return (
            <div className="flex justify-center items-center h-[400px]">
                <div className="w-12 h-12 border-4 border-gray-300 border-t-[#0F3460] rounded-full animate-spin"></div>
            </div>
        )
    }

    return (
        <>
            <section
                className="relative overflow-hidden mt-[66px] lg:mt-[72px]"
                data-aos="fade-in"
                data-aos-duration="1200"
            >
                <img
                    src="/assets/what/the coridor banner.jpg"
                    alt="Corridor Background"
                    className="h-[280px] sm:h-[320px] md:h-[340px] lg:h-[363px] w-full object-cover"
                />
                <div
                    className="absolute inset-0 bg-black/45 lg:bg-black/50"
                    data-aos="fade-in"
                    data-aos-delay="150"
                ></div>

                <div className="absolute inset-0 flex items-center">
                    <div className="max-w-[1440px] mx-auto w-full px-[20px] lg:px-[70px]">
                        <div className="max-w-[700px]">
                            <h6
                                data-aos="fade-up"
                                data-aos-delay="150"
                                className=" pb-[0px] font-neue font-[400] text-[28px] md:text-[36px] leading-[40px] md:leading-[52px] text-[#ffff] text-left mt-[10px]"
                            >Insights
                            </h6>

                            <h6
                                data-aos="fade-up"
                                data-aos-delay="400"
                                className="pt-[2px] pb-[8px] font-neue font-[400] text-white text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] leading-[30px] sm:leading-[38px] md:leading-[46px] lg:leading-[52px]"
                            >
                                What we track, and what we publish.
                            </h6>

                        </div>
                    </div>
                </div>
            </section >




            <section className='lg:py-[50px] py-[50px] lg:px-[20px] px-[20px] pt-[60px] sm:pt-[80px] lg:pt-[100px] pb-[60px] sm:pb-[80px] lg:pb-[100px]' style={{ background: "linear-gradient(180deg, rgba(15, 52, 96, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%)" }}>
                {/* <div
                    className="max-w-[1240px] w-full mx-auto py-[44px] flex flex-col lg:flex-row lg:justify-between lg:items-center rounded-[30px] bg-[#FFFFFF]"
                    style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}
                >
                    <div className="max-w-[485px] w-full flex flex-col items-center lg:items-start text-center lg:text-left px-[20px] lg:pl-[80px]">
                        <h6 className="font-[400] font-neue text-[32px] lg:text-[44px] leading-[40px] lg:leading-[44px] tracking-[-0.16px] text-[#0F3460] pb-[20px] lg:pb-[40px]">
                            DOT Weekly
                        </h6>
                        <p className="font-[400] font-neue text-[14px] lg:text-[16px] leading-[26px] lg:leading-[30px] tracking-[-0.22px] text-[#05003E] pb-[16px]">
                            A weekly signal from the corridor — without the noise. Cross-border deals,
                            emerging tech, policy shifts, military updates, unseen alignments, and
                            more. Delivered straight to your inbox.
                        </p>
                        <button
                            style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                            className="py-[12px] px-[28px] lg:px-[40px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[14px] leading-[20px] text-center text-[#FFFFFF]"
                        >
                            Subscribe Now
                        </button>
                    </div>
                    <div className="max-w-[542px] w-full mt-[30px] lg:mt-0 lg:mr-[40px] px-[20px] lg:px-0">
                        <img src="/assets/what/img1.png" className="rounded-[20px] w-full" alt="" />
                    </div>
                </div> */}
                <div className="flex flex-col items-start max-w-[1440px] mx-auto px-[20px] lg:px-[70px] ">
                    <h6
                        data-aos="fade-up"
                        data-aos-duration="900"
                        data-aos-delay="100"
                        className="pt-[8px] pb-[5px] font-neue font-[400] text-[28px] lg:text-[36px] leading-[38px] lg:leading-[52px] text-[#000] text-left"
                    >
                        Briefs and reports<span className="text-[#BB872A]"></span>
                    </h6>
                    <div
                        data-aos="zoom-in"
                        data-aos-duration="900"
                        data-aos-delay="250"
                        className="line"
                    ></div>
                    <p
                        data-aos="fade-up"
                        data-aos-duration="900"
                        data-aos-delay="400"
                        className="max-w-[612px] pb-[20px] lg:pb-[20px] w-full font-[400] font-neue text-[14px] lg:text-[16px] leading-[24px] lg:leading-[29px] tracking-[-0.22px] text-[#05003E] text-left mt-[10px]"
                    >
                        We follow the U.S.–India strategic sector closely and publish briefs and reports for those working in it. Request any report below, and we'll send it to your inbox.
                    </p>
                </div>


                <div className="w-full max-w-[1440px] mx-auto px-[0px] lg:px-[70px]">
                    <div className="flex justify-center gap-6 mt-6 mb-6">
                        <button
                            onClick={() => setActiveTab("DotWeekly")}
                            className={`pb-2 text-[20px] font-neue font-[500] border-b-2 transition-all duration-300 ${activeTab === "DotWeekly" ? "border-[#BB872A] text-[#BB872A]" : "border-transparent text-[#000]"}`}
                        >
                            Dot Weekly
                        </button>
                        <button
                            onClick={() => setActiveTab("Briefs")}
                            className={`pb-2 text-[20px] font-neue font-[500] border-b-2 transition-all duration-300 ${activeTab === "Briefs" ? "border-[#BB872A] text-[#BB872A]" : "border-transparent text-[#000]"}`}
                        >
                            Briefs
                        </button>
                        <button
                            onClick={() => setActiveTab("Reports")}
                            className={`pb-2 text-[20px] font-neue font-[500] border-b-2 transition-all duration-300 ${activeTab === "Reports" ? "border-[#BB872A] text-[#BB872A]" : "border-transparent text-[#000]"}`}
                        >
                            Reports
                        </button>
                    </div>
                    {activeTab == 'DotWeekly' && (
                        isUploading ? (
                            <Loading />
                        ) : (
                            <>
                                <div className="grid pb-[30px] lg:grid-cols-4 grid-cols-1 lg:gap-[25px] gap-[14px]">
                                    {AllDotweekly?.slice(0, visibleCount)?.map((item) => (
                                        <a
                                            key={item?.id}
                                            href={toHttps(item?.archiveUrl)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="relative block overflow-hidden max-w-[96%] w-full cursor-pointer"
                                        >
                                            <p className="py-[8px] px-[8px] bg-[#0F3460] font-heebo text-[12px] uppercase text-white absolute top-0 left-0 z-[2]">
                                                {activeTab}
                                            </p>

                                            <img
                                                src={DotWeeklyimg}
                                                className="h-[376px] object-cover w-full"
                                                alt={getTitle(item)}
                                            />

                                            <div
                                                className="absolute bottom-0 left-0 w-full pl-[10px] pr-[10px] bg-[#BC872B] flex flex-col justify-center"
                                                style={{ height: "110px", borderRadius: "0px 40px 0 0" }}
                                            >
                                                <p className="max-w-[85%] font-neue font-bold text-[16px] leading-[24px] tracking-[-0.2px] text-white line-clamp-3">
                                                    {getTitle(item)}
                                                </p>
                                                <span className="text-[12px] text-white/80 mt-[2px]">
                                                    {formatDate(item?.sendTime)}
                                                </span>
                                            </div>
                                        </a>
                                    ))}
                                </div>
                                {visibleCount < AllDotweekly?.length && (
                                    <div className="flex justify-center" data-aos="zoom-in">
                                        <button
                                            onClick={handleViewMore}
                                            style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                            className="py-[12px] px-[15px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[14px] text-white"
                                        >
                                            View More
                                        </button>
                                    </div>
                                )}

                            </>
                        )
                    )}
                    {activeTab == 'Reports' && (
                        isUploading ? (
                            <Loading />
                        ) : (
                            <>
                                <div className="grid pb-[30px] lg:grid-cols-4 grid-cols-1 lg:gap-[25px] gap-[14px]">
                                    {AllReport?.slice(0, visibleCount)?.map((item, index) => (
                                        <div
                                            key={index}
                                            onClick={() => OpenReportRequest(item?._id)}
                                            className="relative overflow-hidden max-w-[96%] w-full cursor-pointer"
                                        >
                                            {/* TOP TAG */}
                                            <p className="py-[8px] px-[8px] bg-[#0F3460] font-heebo text-[12px] uppercase text-white absolute top-[0px] left-[0px] z-[2]">
                                                {activeTab}
                                            </p>

                                            {/* IMAGE */}
                                            <img
                                                src={item?.Image || "/assets/home/default-img.png"}
                                                className="h-[376px] object-cover w-full"
                                                alt={item?.Title}
                                            />

                                            {/* TEXT SECTION (REPLACEMENT OF wrapper2.svg) */}
                                            <div className=" absolute bottom-0 left-0 w-full pl-[10px] bg-[#BC872B] flex items-center " style={{ height: "110px", borderRadius: "0px 40px 0 0" }}>
                                                <p className=" max-w-[85%] font-neue font-bold text-[16px] leading-[24px] tracking-[-0.2px] text-white line-clamp-3" >
                                                    {item?.Title || "No title"}
                                                </p>
                                            </div>
                                        </div>

                                    ))}
                                </div>
                                {visibleCount < AllReport?.length && (
                                    <div className="flex justify-center" data-aos="zoom-in">
                                        <button
                                            onClick={handleViewMore}
                                            style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                            className="py-[12px] px-[15px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[14px] text-white"
                                        >
                                            View More
                                        </button>
                                    </div>
                                )}

                            </>
                        )
                    )}
                    {activeTab == 'Briefs' && (
                        isUploading ? (
                            <Loading />
                        ) : (
                            <>
                                <div className="grid pb-[30px] lg:grid-cols-4 grid-cols-1 lg:gap-[25px] gap-[14px]">
                                    {AllBriefs?.slice(0, visibleCount)?.map((item, index) => (
                                        <div
                                            key={index}
                                            onClick={() => OpenReportRequest(item?._id)}
                                            className="relative overflow-hidden max-w-[96%] w-full cursor-pointer"
                                        >
                                            {/* TOP TAG */}
                                            <p className="py-[8px] px-[8px] bg-[#0F3460] font-heebo text-[12px] uppercase text-white absolute top-[0px] left-[0px] z-[2]">
                                                {activeTab}
                                            </p>

                                            {/* IMAGE */}
                                            <img
                                                src={item?.Image || "/assets/home/default-img.png"}
                                                className="h-[376px] object-cover w-full"
                                                alt={item?.Title}
                                            />

                                            {/* BOTTOM TEXT SECTION */}
                                            <div className="absolute bottom-0 left-0 w-full pl-[10px] bg-[#BC872B] flex items-center " style={{ height: "110px", borderRadius: "0px 40px 0 0" }}>
                                                <p className=" max-w-[85%] font-neue font-bold text-[16px] leading-[24px] tracking-[-0.2px] text-white line-clamp-3" >
                                                    {item?.Title || "No title"}
                                                </p>
                                            </div>
                                        </div>

                                    ))}
                                </div>
                                {visibleCount < AllBriefs?.length && (
                                    <div className="flex justify-center" data-aos="zoom-in">
                                        <button
                                            onClick={handleViewMore}
                                            style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                                            className="py-[12px] px-[15px] transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[14px] text-white"
                                        >
                                            View More
                                        </button>
                                    </div>
                                )}

                            </>
                        )
                    )}
                </div>
            </section>
            {/* <section className='relative'>
                <img src="/assets/what/bg2.png" className='h-[539px] w-full object-cover' alt="" />
                <div className="absolute inset-0 bg-black/70 rounded-[20px]"></div>
                <div className="absolute z-10 top-0 left-[50%] translate-x-[-50%] pt-[114px] flex flex-col items-center">
                    <h6 className="pb-[15px] text-center font-neue font-[400] text-[36px] leading-[52px] text-[#FFFFFF]">
                        We’re not a marketplace.  <span className='text-[#fff] italic'> We’re a corridor.</span>
                    </h6>
                    <p className="font-[400] font-neue text-[16px] leading-[30px] tracking-[-0.22px] text-center text-[#FFFFFF] pb-[33px]">If you think we’re aligned</p>
                    <button style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }} className='py-[12px] px-[15px] transition-all duration-500 hover:bg-[#FFFFFF] hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[14px] leading-[20px] text-center text-[#FFFFFF]'>Get In Touch</button>
                </div>
            </section> */}

            <div className='newletters-div overflow-hidden px-[20px] lg:px-[100px] pb-[60px] sm:pb-[80px] lg:pb-[100px]'>
                <TwitterCompoent />
            </div>

            {/* <div className='the-corridor-div  the-corridor-div21212' >

                <div className=' max-w-[1440px] mx-auto px-[20px] lg:px-[70px]'>
                    <h6 className="pb-[15px] text-left font-neue font-[400] text-[36px] leading-[38px] text-[#FFFFFF]">
                        We operate as a corridor, <br /> <span className='text-[#fff] italic'> not a marketplace.</span>
                    </h6>
                    <p className="font-[400] font-neue text-[16px] leading-[10px] tracking-[-0.22px] text-left text-[#FFFFFF] pb-[33px]">If you think we’re aligned</p>
                    <button style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }} className='py-[12px] px-[15px] transition-all duration-500 hover:bg-[#FFFFFF] hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[12px] font-[400] font-neue text-[14px] leading-[20px] text-center text-[#FFFFFF]'>Get In Touch</button>
                </div>
            </div> */}

            <RequestModel
                isOpen={ReportRequestModel}
                onClose={CloseReportRequest}
                Report={selectedReport}
            />
        </>
    )
}

export default TheCorridor
